const filterNumberArray = (numberArray: number[] | undefined, num: number): number[] =>
  numberArray?.filter(item => item !== num) || [];

export default filterNumberArray;
